import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarSubArea = async (subArea) => {
    try {
        if (subArea.id) {
            const resp = await axios.post(
                `${API_URL}/subareas/editar/${subArea.id}`,
                subArea,
                { headers: getHeaders() }
            );

            return resp.data;
        }

        const resp = await axios.post(
            `${API_URL}/subareas`,
            subArea,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const inactivarSubArea = async (id_subArea) => {
    try {
        const resp = await axios.delete(
            `${API_URL}/subareas/${id_subArea}`,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const activarSubArea = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/subareas/activar/${data.id}`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const verSubArea = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/subareas/verSubArea/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};